// src/composables/useConfig.js
import { ref, onMounted, onUnmounted } from 'vue'

const configGeral = ref({})

function readStorage() {
  try {
    configGeral.value = JSON.parse(
      localStorage.getItem('configGeral') || '{}'
    )
  } catch {
    configGeral.value = {}
  }
}

/**
 * useConfig devolve:
 *  - configGeral: ref reativo com as configs
 *  - reloadConfig: fn para forçar ler de novo (na mesma aba)
 */
export function useConfig() {
  // lê ao importar pela primeira vez (evita undefined)
  readStorage()

  // handler para o event storage
  function onStorage(e) {
    if (e.key === 'configGeral') {
      readStorage()
    }
  }

  onMounted(() => {
    // escuta mudanças de localStorage em outras janelas/abas
    window.addEventListener('storage', onStorage)
  })
  onUnmounted(() => {
    window.removeEventListener('storage', onStorage)
  })

  return {
    configGeral,
    reloadConfig: readStorage
  }
}
